import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import SignUp from "./pages/Authentication/Signup/Signup";
import Login from "./pages/Authentication/Login/Login";
import ForgotPassword from "./pages/Authentication/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/Authentication/ResetPassword/ResetPassword";
import Verification from "./pages/Authentication/Verification/Verification";
import VerifyAccount from "./pages/Authentication/Signup/VerifyAccount";
import ValidateResetPassword from "./pages/Authentication/ForgotPassword/ValidateResetPassword";

import DefaultLayout from "./layouts/DefaultLayout";
import Dashboard from "./pages/Dashboard/Dashboard";
import Campaigns from "./pages/Campaigns/Campaigns";
import CreateCampaign from "./pages/Campaigns/CreateCampaign/CreateCampaign";
import EditCampaign from "./pages/Campaigns/EditCampaign";
import ViewCampaign from "./pages/Campaigns/ViewCampaign/ViewCampaign";
import Reports from "./pages/Reports/Reports";
import ViewReport from "./pages/Reports/ViewReport";
import Billing from "./pages/Billing/Billing";
import Profile from "./pages/Profile/Profile";
import DailyCampaign from "./pages/Reports/DailyCampaign"

const AppRoutes = () => {
  const { accessToken } = useSelector((state) => state.auth);
  return (
    <>
      <Router>
        <Routes>
          {/* Authentication */}
          <Route
            path="/login"
            element={!accessToken ? <Login /> : <Navigate to="/" />}
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-reset-password" element={<ValidateResetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/verification-notifier/:email" element={<Verification />} />
          <Route path="/verify-email" element={<VerifyAccount />} />
          {/* Pages */}
          <Route
            path="/"
            element={accessToken ? <DefaultLayout /> : <Navigate to="/login" />}
          >
            <Route index element={<Dashboard />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/create-campaign" element={<CreateCampaign />} />
            <Route path="/edit-campaign/:campaignId" element={<EditCampaign />} />
            <Route path="/view-campaign/:campaignId" element={<ViewCampaign />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/view-report/:monthYear" element={<ViewReport />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/daily-campaign" element={<DailyCampaign />} />
          </Route>
        </Routes>
      </Router>
    </>
  );
};

export default AppRoutes;
